import { render, staticRenderFns } from "./userBasicInformationCni.vue?vue&type=template&id=6a873c12&"
import script from "./userBasicInformationCni.vue?vue&type=script&lang=ts&"
export * from "./userBasicInformationCni.vue?vue&type=script&lang=ts&"
import style0 from "./userBasicInformationCni.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports